import api from 'api'
import { DropdownItem } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import { reportFormatDate, useHandleImpressao } from 'hooks/impressao/useHandleImpressao'

interface AtendimentoInativoActionsProps {
  coUnicoAtendProf: string
}

export function AtendimentoInativoActions(props: Readonly<AtendimentoInativoActionsProps>) {
  const { coUnicoAtendProf } = props
  const { handleImpressaoPath, handleImpressaoError } = useHandleImpressao()

  const imprimirRegistrosInativos = (coUnicoAtendProf: string) =>
    handleImpressaoPath({
      apiPath: api.retificacaoAtendimento.imprimirRegistrosInativos,
      values: coUnicoAtendProf,
      file: `AtendimentoInativo`,
      dateFormat: reportFormatDate,
    })

  const imprimirAuditoria = (coUnicoAtendProf: string) =>
    handleImpressaoPath({
      apiPath: api.retificacaoAtendimento.imprimirAuditoria,
      values: coUnicoAtendProf,
      file: 'Trilha de auditoria',
      dateFormat: 'yyyyMMddHHmmss',
    }).catch(handleImpressaoError)

  return (
    <DropdownButton stopPropagationOnAction>
      <DropdownItem onClick={() => imprimirRegistrosInativos(coUnicoAtendProf)}>
        Imprimir registros inativos
      </DropdownItem>
      <DropdownItem onClick={() => imprimirAuditoria(coUnicoAtendProf)}>Imprimir auditoria do registro</DropdownItem>
    </DropdownButton>
  )
}
